/**
 * Static cache mapping currency codes to their Intl.NumberFormat instances
 */
const currencyFormatterCache = new Map<string, Intl.NumberFormat>();

/**
 * Gets or creates a currency formatter from cache
 */
export default function getCurrencyFormatter(currencyCode: string): Intl.NumberFormat {
    let formatter = currencyFormatterCache.get(currencyCode);
    if (!formatter) {
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencyCode,
            //minimumFractionDigits: 2,
            //maximumFractionDigits: 2,
        });
        currencyFormatterCache.set(currencyCode, formatter);
    }
    return formatter;
}
